export const READY = "ready";
export const FETCHING = "fetching";

export const FETCH = "NV.FETCH";
